import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.g6w_1 = partyId;
        this.h6w_1 = pinId;
        this.i6w_1 = icon;
        this.j6w_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.g6w_1.toString() + ', pinId=' + this.h6w_1.toString() + ', icon=' + this.i6w_1 + ', name=' + this.j6w_1 + ')';
      }
      hashCode() {
        var result = this.g6w_1.hashCode();
        result = imul(result, 31) + this.h6w_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.i6w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j6w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.g6w_1.equals(other.g6w_1))
          return false;
        if (!this.h6w_1.equals(other.h6w_1))
          return false;
        if (!(this.i6w_1 === other.i6w_1))
          return false;
        if (!(this.j6w_1 === other.j6w_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
